<template>
  <wz-modal
    v-model="visible"
    title="Documentación incompleta"
    :close-on-overlay="false"
  >
    <div class="flex items-start mb-3">
      <i class="ri-lock-line mr-2 text-danger" style="font-size:1.4rem; flex-shrink:0;"></i>
      <p class="mb-0">{{ message }}</p>
    </div>

    <div v-if="missingDocuments && missingDocuments.length" class="mb-3">
      <strong class="text-danger">Documentos faltantes:</strong>
      <ul class="mt-2 mb-0">
        <li v-for="doc in missingDocuments" :key="doc">{{ doc }}</li>
      </ul>
    </div>

    <template #footer>
      <wz-button variant="outline-secondary" @click="close">Cerrar</wz-button>
      <wz-button v-if="employeeId" variant="primary" @click="goToLegajo">
        <i class="ri-folder-open-line mr-1"></i>Ir a Legajo documental
      </wz-button>
    </template>
  </wz-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'DocumentComplianceModal',
  computed: {
    ...mapState('compliance', ['error']),
    visible: {
      get() { return !!this.error },
      set(val) { if (!val) this.clearError() },
    },
    message()          { return this.error ? this.error.message          : '' },
    missingDocuments() { return this.error ? this.error.missingDocuments : [] },
    employeeId()       { return this.error ? this.error.employeeId       : null },
  },
  methods: {
    ...mapMutations('compliance', ['clearError']),
    close() { this.clearError() },
    goToLegajo() {
      const id = String(this.employeeId)
      this.close()
      this.$router.push({ name: 'employee-details', params: { id } }).catch(() => {})
    },
  },
}
</script>
